import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=bf377154&scoped=true"
import script from "./mail.vue?vue&type=script&lang=js"
export * from "./mail.vue?vue&type=script&lang=js"
import style0 from "./mail.vue?vue&type=style&index=0&id=bf377154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf377154",
  null
  
)

export default component.exports